import { Component, OnInit } from '@angular/core';
import { PopupNovaOcorrenciaService } from '../popup-nova-ocorrencia/popup-nova-ocorrencia.service';
import { Util } from '../shared/util.service';
import { MainContainerService } from '../main-container/main-container.service';
import * as moment from 'moment';
import { PopupOcorrenciaService } from '../popup-ocorrencia/popup-ocorrencia.service';
import { ObjectParam } from '../interface/generic-interface';

declare var jquery: any;
declare var $: any; 

@Component({
  standalone: false,
  selector: 'popup-nova-ocorrencia',
  templateUrl: './popup-nova-ocorrencia.component.html',
  styleUrls: ['./popup-nova-ocorrencia.component.css']
})

export class PopupNovaOcorrenciaComponent implements OnInit {

  public IdMensagem: number;
  public CodigoOcorrencia: string;
  public IdOrigem: number;
  public IdMotivo: number = 0;
  public msgValMotivo: string = '';
  public IdStatus: number;
  public NumeroRoteiro: number;
  public Mensagem: string;
  public Data: Date;
  public Transmitido: number;
  public motivoSelecionado: string;
  public listaMotivos: any[] = [];
  public listaOcorrencia: any[] = [];

  constructor(
    private popupNovaOcorrenciaService: PopupNovaOcorrenciaService,
    private util: Util,
    private mainContainerService: MainContainerService,
    private popupOcorrenciaService: PopupOcorrenciaService
  ) {

  }

  loadingCriarOcorrencia = false;
  async ngOnInit() {
    await this.listaMotivoOcorrencia();
  }

  LimparCampos() {
    $('#motivo').val('0');
    $('#observacao').val('');
  }

  async cadastraOcorrencia() {
    this.mainContainerService.loadingProcessando = true;
    this.loadingCriarOcorrencia = true;
    if (this.IdMotivo > 0) {
      const roteiro = this.mainContainerService.listOcorrenciasRoteiroStatus[0].roteiro;
      await this.listarOcorrencia(roteiro);
      this.CodigoOcorrencia = this.geraIndiceOcorrencia(this.mainContainerService.listOcorrenciasRoteiroStatus[0].roteiro)
      this.IdStatus = 2;
      this.Transmitido = 0;
      this.IdMensagem = 0;
      let objParam: ObjectParam = {
        ocorrencias: {
          CodigoOcorrencia: this.CodigoOcorrencia,
          IdMotivo: Number(this.IdMotivo),
          IdStatus: this.IdStatus,
          NumeroRoteiro: this.mainContainerService.listOcorrenciasRoteiroStatus[0].roteiro,
          Data: this.util.converterDataSemFuso(new Date()),
        }
      }
      this.mainContainerService.ocorrenciaSelecionado = [];
      this.mainContainerService.ocorrenciaSelecionado.push(objParam.ocorrencias);

      const respOcorrencia = await this.popupNovaOcorrenciaService.postCadastraOcorrencia(objParam);

      this.IdOrigem = 1;
      this.Mensagem === undefined ? this.Mensagem = '' : this.Mensagem = this.Mensagem;
      let objParamMsg: ObjectParam = {
        ocorrenciaMensagem: {
          IdOrigem: this.IdOrigem,
          CodigoOcorrencia: this.CodigoOcorrencia,
          Mensagem: this.Mensagem,
          Data: this.util.converterDataSemFuso(new Date()),
          IdOcorrencia: respOcorrencia.response[0].IdOcorrencia
        }
      }

      this.Mensagem = '';
      this.IdMotivo = 0;
      $('#nova-ocorrencia').modal('hide');
      const respMensagem = await this.popupNovaOcorrenciaService.postCadastraOcorrenciaMsg(objParamMsg);
      document.getElementById('btnAtualizaListaOcorrencias').click()

      if(this.popupOcorrenciaService.updateRoteiroAlerta){
        let response = await this.mainContainerService.getAlertaId(this.popupOcorrenciaService.roteiroAlertaId);

        let objParam: ObjectParam = {
          roteiroAlerta: {
            RoteiroID: response[0].RoteiroID,
            AlertaPainelID: response[0].AlertaPainelID,
            CoordenadaID: response[0].CoordenadaID,
            OcorrenciaID: respOcorrencia[0].IdOcorrencia,
            Visualizado: response[0].Visualizado,
            RoteiroAlertaID: this.popupOcorrenciaService.roteiroAlertaId
          }
        }
        await this.mainContainerService.updateAlertaId(this.popupOcorrenciaService.roteiroAlertaId, objParam);
        this.popupOcorrenciaService.updateRoteiroAlerta = false;
      }      

      // Chamar função aviso de confirmação 
    } else {
      this.msgValMotivo = 'Favor selecionar o Motivo';      
    }  
    this.loadingCriarOcorrencia = false;  
  }

  async listaMotivoOcorrencia() {
    const response = await this.popupNovaOcorrenciaService.getMotivoOcorrencia();
    this.listaMotivos = response;
    this.listaMotivos = this.listaMotivos.filter((element) => !element.Descricao.includes('- OC Aut'))
    this.IdMotivo = response[0].IdMotivo;

    await this.onChangeObj(response[0]);
  }

  async onChangeObj(motivo: any) {
    this.IdMotivo = motivo;
  }

  async listarOcorrencia(NumeroRoteiro) {
    const response = await this.popupNovaOcorrenciaService.getOcorrencia(NumeroRoteiro);
    this.listaOcorrencia = response;
  }

  geraIndiceOcorrencia(numeroRoteiro){
    let now = moment(new Date());
    let nowGet = new Date();
    let darkSoulsTime = moment.utc('2011-09-22'); 
    const diff = moment.duration(now.diff(darkSoulsTime)); 
   
    let indiceOcorrencia =  Math.trunc(diff.asDays()) + numeroRoteiro.toString() + nowGet.getHours().toString() + nowGet.getMinutes().toString() + nowGet.getSeconds().toString();
    return indiceOcorrencia + '-P';
  }
}
